export default "__VITE_ASSET__DhfX0kOm__"